export default __webpack_public_path__ + "static/media/red-tick.bdd290b5.svg";